import { ToggleSurveySentAction, SurveyState, ChangeTypeOfFinalTransactionCompletedAction } from "./type";

export function toggleSurveySentStatusHandler(state: SurveyState, action: ToggleSurveySentAction): SurveyState {
    return Object.assign({}, state, { surveySent: action.payload.surveySent });
}

export function changeTypeFinalOfTransactionCompletedHandler(state: SurveyState, action: ChangeTypeOfFinalTransactionCompletedAction): SurveyState {
    return Object.assign({}, state,
        {
            typeOfFinalTransactionCompleted: action.payload.typeOfFinalTransactionCompleted,
            errorCode: action.payload.errorCode
        });
}


// WEBPACK FOOTER //
// ./src/store/Survey/handlers.ts